export const TABLE_CONFIG = {
  HEADER_HEIGHT: 'auto',
  CELL_PADDING: 0,
  BORDER_RIGHT: '1px solid rgba(217, 217, 217, 0.1)',
};

export const METRIC_COLORS = {
  SOCIAL: "#00E1AF",
  MENU: "#00B4FF", 
  CONSUMER: "#FF5AB9",
};

export const METRIC_GRADIENTS = {
  SOCIAL: "linear-gradient(360deg, #00E1AF 20%, #0A9C8D 100%)",
  MENU: "linear-gradient(360deg, #00B4FF 20%, #006EF5 100%)",
  CONSUMER: "linear-gradient(180deg, #EB0089 0%, #FF5AB9 80%)",
};

export const COLUMN_SPANS = {
  SINGLE: 1,
  DOUBLE: 2,
  TRIPLE: 3,
};